/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {configuracaoRoute, editRoute, newRoute} from '../../shared/services/data.service';
import { ObrigacaoFormComponent } from "./obrigacao-form/obrigacao-form.component";
import { ObrigacaoListComponent } from "./obrigacao-list/obrigacao-list.component";
import { ObrigacaoTipoFormComponent } from "./obrigacao-tipos/obrigacao-tipo-form/obrigacao-tipo-form.component";
import { obrigacaoTiposRoute } from "./obrigacao-tipos/shared/data.service";
import { ObrigacaoTipoListComponent } from "./obrigacao-tipos/obrigacao-tipo-list/obrigacao-tipo-list.component";
import {DespachoConfiguracaoObrigacoesComponent} from "../configuracao/configuracao-obrigacoes/despacho-configuracao-obrigacoes.component";
import {licenciamentosRoute} from "../licenciamentos/shared/data.service";
import {LicenciamentosComponent} from "../licenciamentos/licenciamentos.component";
import {licenciamentosRoutes} from "../licenciamentos/licenciamentos-routing.module";
import {AuthGuardService} from "../../shared/services/auth-guard.service";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class ObrigacoesRoutingModule {}

export const obrigacoesRoutes: any[] = [
    {
        path: '',
        component: ObrigacaoListComponent
    },{
        path: editRoute + '/:id',
        component: ObrigacaoFormComponent
    },{
        path: newRoute,
        component: ObrigacaoFormComponent
    },{
        path: configuracaoRoute,
        component: DespachoConfiguracaoObrigacoesComponent
    },{
        path: configuracaoRoute + '/' + obrigacaoTiposRoute,
        component: ObrigacaoTipoListComponent
    },{
        path: configuracaoRoute + '/' + obrigacaoTiposRoute + '/' + newRoute,
        component: ObrigacaoTipoFormComponent
    },{
        path: configuracaoRoute + '/' + obrigacaoTiposRoute + '/' + editRoute + '/:id',
        component: ObrigacaoTipoFormComponent
    },{
        path: configuracaoRoute + '/' + licenciamentosRoute,
        component: LicenciamentosComponent,
        canActivateChildren: [AuthGuardService],
        children: licenciamentosRoutes
    }

];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/obrigacoes-routing.module.ts
 **/